export default __webpack_public_path__ + "static/media/bill-icon.43da563c.svg";